<div 
  class="onboarding-overlay" 
  *ngIf="currentPage"
>
  <div class="onboarding-modal">
    <div class="onboarding-title">
      {{ 'ONBOARDING.COMMON.QUICK-TOUR' | translate }}
      
    </div>
    <div class="onboarding-progress">
      <span>{{ index + 1 }}/{{ total }}</span>
    </div>
    <div class="onboarding-content">
      <p>
        {{ currentPage.textTranslationKey | translate }}
      </p>
    </div>
    <div class="onboarding-actions">
      <button *ngIf="index !== 0" class="btn-back" (click)="back()" >
        {{ 'COMMON.BACK' | translate }}
      </button>
      <button class="btn-next" (click)="next()">
        {{ isLast 
          ? ('COMMON.DONE' | translate)
          : ('COMMON.NEXT' | translate) 
        }}
      </button>
    </div>
    <div class="onboarding-skip" (click)="skip()">
      {{ 'ONBOARDING.COMMON.SKIP-TOUR' | translate }}
    </div>
  </div>
</div>

@if(showProvidedTenantSubscriptionModal && tenantSubscription) {
  <app-provided-tenant-subscription-modal
    [(showModal)]="showProvidedTenantSubscriptionModal"
    [tenantName]="tenantSubscription.tenantSubscription.name"
    [invitedDate]="providedTenantInvitedDate"
    [trainingsCount]="tenantSubscription.trainings.length"
    [categoriesCount]="tenantSubscription.standardCategories.length"
    [standardCategories]="tenantSubscription.standardCategories"
    (subscribe)="subscribeToProvidedTenant($event)"
    (skip)="skipSubscribingToProvidedTenant()"
  ></app-provided-tenant-subscription-modal>
}

@if(showContentUnlockedModal && tenantSubscription) {
  <app-content-unlocked-modal
    [(showModal)]="showContentUnlockedModal"
    [trainingsCount]="tenantSubscription.trainings.length"
    [categoriesCount]="tenantSubscription.standardCategories.length"
    (continue)="onContentUnlockedContinue()"
  ></app-content-unlocked-modal>
}
